import {getNow} from 'util/utils';

export default class Grant {
    constructor(data) {
        this.accessToken = (data && data.accessToken) || null;
        this.accessTokenExpiresIn = (data && data.accessTokenExpiresIn) || null;
        this.refreshToken = (data && data.refreshToken) || null;
        this.lastUpdate = (data && data.lastUpdate) || null;
    }
}

export const newGrantFromJSON = (json = {}) => new Grant({
    accessToken:          json.access_token,
    accessTokenExpiresIn: json.expires_in,
    refreshToken:         json.refresh_token,
    lastUpdate:           getNow()
});



// WEBPACK FOOTER //
// ./src/util/api/Grant.js